module.exports = __webpack_public_path__ + "static/media/Band Members.ff56ebc2.png";